export const isWeakRefSupported = (): boolean => {
  return typeof WeakRef !== 'undefined';
};

class WeakRefPolyfill<T> {
  private target: T;

  constructor(target: T) {
    this.target = target;
  }

  deref(): T | undefined {
    return this.target;
  }
}

export const createWeakRef = <T extends object>(target: T): WeakRef<T> => {
  if (isWeakRefSupported()) {
    return new WeakRef(target);
  }

  return new WeakRefPolyfill(target) as unknown as WeakRef<T>;
};
